// extracted by mini-css-extract-plugin
module.exports = {"container":"gameHistory_container__1CzD8","wrapper":"gameHistory_wrapper__1DtfJ","header":"gameHistory_header__1DCv_"};